/**
 * The Continuity page's repeat-search question (MYAC-1612, 23/10) has its own
 * `ConfirmDialog` instance, mounted once in `App.vue` next to the action plan's
 * — the same reason as there: a two-sentence question gets a compact box
 * instead of the band the ungrouped dialog stretches to across the viewport
 * (Arslene, 23/10: « too large on the x axis »), and changing how this one asks
 * never changes how anything else in the product asks.
 */
export const CONTINUITY_SEARCH_CONFIRM_GROUP = 'continuity-date-search'
